import logoImg from "./images/img/logoImg.png";
import authImage from "./images/img/authImage.png";
import authImageSmall from "./images/img/authImageSmall.png";
import homeBanner from "./images/img/homeBanner.png";
import homeBannerSmall from "./images/img/homeBannerSmall.png";

import { ReactComponent as EyeSvg } from "./images/svg/EyeSvg.svg";
import { ReactComponent as EyeSlashSvg } from "./images/svg/EyeSlashSvg.svg";
import { ReactComponent as LockPassSvg } from "./images/svg/LockPassSvg.svg";
import { ReactComponent as SmsSvg } from "./images/svg/SmsSvg.svg";
import { ReactComponent as LogInSvg } from "./images/svg/LogInSvg.svg";
import { ReactComponent as ForgotSvg } from "./images/svg/ForgotSvg.svg";
import { ReactComponent as ArrowLeftBack } from "./images/svg/ArrowLeftBack.svg";
import { ReactComponent as ArrowDownSvg } from "./images/svg/ArrowDownSvg.svg";
import { ReactComponent as ResetSvg } from "./images/svg/ResetSvg.svg";
import { ReactComponent as CheckSvg } from "./images/svg/CheckSvg.svg";
import { ReactComponent as XSvg } from "./images/svg/XSvg.svg";
import { ReactComponent as LogoWithoutText } from "./images/svg/LogoWithoutText.svg";
import { ReactComponent as DispatchBoardMenu } from "./images/svg/DispatchBoardMenu.svg";
import { ReactComponent as ArrowCollapseSvg } from "./images/svg/ArrowCollapseSvg.svg";
import { ReactComponent as EditInfoSvg } from "./images/svg/EditInfoSvg.svg";
import { ReactComponent as FileUploaderSvg } from "./images/svg/FileUploaderSvg.svg";
import { ReactComponent as SignOutSvg } from "./images/svg/SignOutSvg.svg";
import { ReactComponent as ProfileSvg } from "./images/svg/ProfileSvg.svg";
import { ReactComponent as CloseButtonSvg } from "./images/svg/CloseButtonSvg.svg";
import { ReactComponent as ArrowRightSvg } from "./images/svg/ArrowRightSvg.svg";
import { ReactComponent as PlusSvg } from "./images/svg/PlusSvg.svg";
import { ReactComponent as SortSvg } from "./images/svg/SortSvg.svg";
import { ReactComponent as SortSvgASC } from "./images/svg/SortSvgASC.svg";
import { ReactComponent as SortSvgDESC } from "./images/svg/SortSvgDESC.svg";
import { ReactComponent as LatestEarliestSvg } from "./images/svg/LatestEarliestSvg.svg";
import { ReactComponent as LatestEarliestWhiteSvg } from "./images/svg/LatestEarliestWhiteSvg.svg";
import { ReactComponent as CloseSvg } from "./images/svg/CloseSvg.svg";
import { ReactComponent as TrashSvg } from "./images/svg/TrashSvg.svg";
import { ReactComponent as Trash2Svg } from "./images/svg/Trash2Svg.svg";
import { ReactComponent as DeleteModalSvg } from "./images/svg/DeleteModalSvg.svg";
import { ReactComponent as NoShowModalSvg } from "./images/svg/NoShowModalSvg.svg";
import { ReactComponent as ArrowUpSvg } from "./images/svg/ArrowUpSvg.svg";
import { ReactComponent as NotesEmptySvg } from "./images/svg/NotesEmptySvg.svg";
import { ReactComponent as FilterSvg } from "./images/svg/FilterSvg.svg";
import { ReactComponent as CheckboxSvg } from "./images/svg/CheckboxSvg.svg";
import { ReactComponent as CheckboxCheckedSvg } from "./images/svg/CheckboxCheckedSvg.svg";
import { ReactComponent as CalendarSvg } from "./images/svg/CalendarSvg.svg";
import { ReactComponent as NoteSvg } from "./images/svg/NoteSvg.svg";
import { ReactComponent as Note2Svg } from "./images/svg/Note2Svg.svg";
import { ReactComponent as SettingsSvg } from "./images/svg/SettingsSvg.svg";
import { ReactComponent as SwitchSvg } from "./images/svg/SwitchSvg.svg";
import { ReactComponent as SwitchCheckedSvg } from "./images/svg/SwitchCheckedSvg.svg";
import { ReactComponent as CancelSvg } from "./images/svg/CancelSvg.svg";
import { ReactComponent as NoShowSvg } from "./images/svg/NoShowSvg.svg";
import { ReactComponent as RepeatSvg } from "./images/svg/RepeatSvg.svg";
import { ReactComponent as EscortPickupSvg } from "./images/svg/EscortPickupSvg.svg";
import { ReactComponent as EscortPickup2Svg } from "./images/svg/EscortPickup2Svg.svg";
import { ReactComponent as EscortDropOf2Svg } from "./images/svg/EscortDropOf2Svg.svg";
import { ReactComponent as MedicationDropSvg } from "./images/svg/MedicationDropSvg.svg";
import { ReactComponent as MedicationDrop2Svg } from "./images/svg/MedicationDrop2Svg.svg";
import { ReactComponent as MedicationDropReturnSvg } from "./images/svg/MedicationDropReturnSvg.svg";
import { ReactComponent as MedicationDropReturn2Svg } from "./images/svg/MedicationDropReturn2Svg.svg";
import { ReactComponent as BusRouteSvg } from "./images/svg/BusRouteSvg.svg";
import { ReactComponent as BusRoute2Svg } from "./images/svg/BusRoute2Svg.svg";
import { ReactComponent as BusRouteReturnSvg } from "./images/svg/BusRouteReturnSvg.svg";
import { ReactComponent as BusRouteReturn2Svg } from "./images/svg/BusRouteReturn2Svg.svg";
import { ReactComponent as EscortDropOfSvg } from "./images/svg/EscortDropOfSvg.svg";
import { ReactComponent as HospitalSvg } from "./images/svg/HospitalSvg.svg";
import { ReactComponent as Hospital2Svg } from "./images/svg/Hospital2Svg.svg";
import { ReactComponent as HouseSvg } from "./images/svg/HouseSvg.svg";
import { ReactComponent as House2Svg } from "./images/svg/House2Svg.svg";
import { ReactComponent as SelectArrowSvg } from "./images/svg/SelectArrowSvg.svg";
import { ReactComponent as PercentageSvg } from "./images/svg/PercentageSvg.svg";
import { ReactComponent as OpenSvg } from "./images/svg/OpenSvg.svg";
import { ReactComponent as AssignedSvg } from "./images/svg/AssignedSvg.svg";
import { ReactComponent as CompletedSvg } from "./images/svg/CompletedSvg.svg";
import { ReactComponent as EnrouteSvg } from "./images/svg/EnrouteSvg.svg";
import { ReactComponent as ArrivedSvg } from "./images/svg/ArrivedSvg.svg";
import { ReactComponent as CanceledSvg } from "./images/svg/CanceledSvg.svg";
import { ReactComponent as ArrowRightSlide } from "./images/svg/ArrowRightSlide.svg";
import { ReactComponent as InfoSvg } from "./images/svg/InfoSvg.svg";
import { ReactComponent as InfoMainSvg } from "./images/svg/InfoMainSvg.svg";
import { ReactComponent as ExportCSVSvg } from "./images/svg/ExportCSVSvg.svg";
import { ReactComponent as ClockSvg } from "./images/svg/ClockSvg.svg";
import { ReactComponent as RefreshSvg } from "./images/svg/RefreshSvg.svg";
import { ReactComponent as Refresh2Svg } from "./images/svg/Refresh2Svg.svg";
import { ReactComponent as PendingTripsMenu } from "./images/svg/PendingTripsMenu.svg";
import { ReactComponent as SelectionSvg } from "./images/svg/SelectionSvg.svg";
import { ReactComponent as PendingSvg } from "./images/svg/PendingSvg.svg";
import { ReactComponent as ActiveSvg } from "./images/svg/ActiveSvg.svg";
import { ReactComponent as InactiveSvg } from "./images/svg/InactiveSvg.svg";
import { ReactComponent as AccessTimeSvg } from "./images/svg/AccessTimeSvg.svg";
import { ReactComponent as EmptyUser } from "./images/svg/EmptyUser.svg";
import { ReactComponent as EmptyEmployees } from "./images/svg/EmptyEmployees.svg";
import { ReactComponent as EmptyFacility } from "./images/svg/EmptyFacility.svg";
import { ReactComponent as EmptyPayer } from "./images/svg/EmptyPayer.svg";
import { ReactComponent as EmptyPatients } from "./images/svg/EmptyPatients.svg";
import { ReactComponent as EmptyVehicle } from "./images/svg/EmptyVehicle.svg";
import { ReactComponent as EmptyTrips } from "./images/svg/EmptyTrips.svg";
import { ReactComponent as OverwriteSvg } from "./images/svg/OverwriteSvg.svg";
import { ReactComponent as UploadSvg } from "./images/svg/UploadSvg.svg";
import { ReactComponent as ImportSvg } from "./images/svg/ImportSvg.svg";
import { ReactComponent as UploadFileTypeSvg } from "./images/svg/UploadFileTypeSvg.svg";
import { ReactComponent as ErrorSvg } from "./images/svg/ErrorSvg.svg";
import { ReactComponent as SuccessSvg } from "./images/svg/SuccessSvg.svg";
import { ReactComponent as Note3Svg } from "./images/svg/Note3Svg.svg";
import { ReactComponent as CopySvg } from "./images/svg/CopySvg.svg";
import { ReactComponent as HistorySvg } from "./images/svg/HistorySvg.svg";
import { ReactComponent as HistoryEmptySvg } from "./images/svg/HistoryEmptySvg.svg";
import { ReactComponent as DatabaseSvg } from "./images/svg/DatabaseSvg.svg";

// menu
import { ReactComponent as UsersMenuSvg } from "./images/svg/UsersMenuSvg.svg";
import { ReactComponent as EmployeeMenu } from "./images/svg/EmployeeMenu.svg";
import { ReactComponent as FacilitiesMenu } from "./images/svg/FacilitiesMenu.svg";
import { ReactComponent as PayerMenu } from "./images/svg/PayerMenu.svg";
import { ReactComponent as PatientsMenu } from "./images/svg/PatientsMenu.svg";

import { ReactComponent as VehiclesMenu } from "./images/svg/VehiclesMenu.svg";
import { ReactComponent as SystemMenu } from "./images/svg/SystemMenu.svg";

export const Images = {
  logoImg,
  authImage,
  authImageSmall,
  homeBanner,
  homeBannerSmall,
};

export const Svg = {
  CopySvg,
  OverwriteSvg,
  Note3Svg,
  SuccessSvg,
  ErrorSvg,
  UploadFileTypeSvg,
  ImportSvg,
  UploadSvg,
  EmptyTrips,
  EmptyVehicle,
  EmptyPatients,
  EmptyPayer,
  EmptyFacility,
  EmptyUser,
  EmptyEmployees,
  AccessTimeSvg,
  RefreshSvg,
  Refresh2Svg,
  InactiveSvg,
  ActiveSvg,
  PendingSvg,
  SelectionSvg,
  PendingTripsMenu,
  ClockSvg,
  ExportCSVSvg,
  InfoSvg,
  InfoMainSvg,
  ArrowRightSlide,
  OpenSvg,
  AssignedSvg,
  CompletedSvg,
  EnrouteSvg,
  ArrivedSvg,
  CanceledSvg,
  PercentageSvg,
  SelectArrowSvg,
  HouseSvg,
  House2Svg,
  HospitalSvg,
  Hospital2Svg,
  EscortPickupSvg,
  EscortPickup2Svg,
  EscortDropOfSvg,
  EscortDropOf2Svg,
  MedicationDropSvg,
  MedicationDropReturnSvg,
  BusRouteSvg,
  BusRouteReturnSvg,
  MedicationDrop2Svg,
  MedicationDropReturn2Svg,
  BusRoute2Svg,
  BusRouteReturn2Svg,
  RepeatSvg,
  CancelSvg,
  NoShowSvg,
  SwitchSvg,
  SwitchCheckedSvg,
  SettingsSvg,
  NoteSvg,
  Note2Svg,
  CalendarSvg,
  CheckboxSvg,
  CheckboxCheckedSvg,
  FilterSvg,
  NotesEmptySvg,
  DeleteModalSvg,
  NoShowModalSvg,
  ArrowUpSvg,
  EyeSvg,
  TrashSvg,
  Trash2Svg,
  CloseSvg,
  EyeSlashSvg,
  LockPassSvg,
  SmsSvg,
  LogInSvg,
  LogoWithoutText,
  ForgotSvg,
  ArrowLeftBack,
  ArrowDownSvg,
  ResetSvg,
  XSvg,
  CheckSvg,
  ArrowCollapseSvg,
  EditInfoSvg,
  FileUploaderSvg,
  SignOutSvg,
  ProfileSvg,
  CloseButtonSvg,
  ArrowRightSvg,
  SortSvg,
  SortSvgASC,
  SortSvgDESC,
  LatestEarliestSvg,
  LatestEarliestWhiteSvg,
  // Menu
  UsersMenuSvg,
  EmployeeMenu,
  FacilitiesMenu,
  PayerMenu,
  PatientsMenu,
  DispatchBoardMenu,
  VehiclesMenu,
  SystemMenu,
  PlusSvg,
  HistorySvg,
  HistoryEmptySvg,
  DatabaseSvg,
};
